module.exports = __webpack_public_path__ + "static/media/tavrika.c1ffbf27.png";